// 财务中心-结算单管理-结算账单(机构)
const OrgSettlementOld = () => import('@pv/orderCenter/finance/OrgIndex');
// 财务中心-结算单管理-结算账单(学校)
const SchSettlementOld = () => import('@pv/orderCenter/finance/SchIndex');
// 财务中心-结算单管理-结算账单-详情(机构)
const OrgSettlementDetailsOld = () =>
  import('@pv/orderCenter/finance/OrgSettlementDetails');
// 财务中心-结算单管理-结算账单-详情(学校)
const SchSettlementDetailsOld = () =>
  import('@pv/orderCenter/finance/OrgSettlementDetails');
// 财务中心-结算单管理-结算账单-机构结算单详情 - 订单明细
const OrgSettlementListOld = () =>
  import('@pv/orderCenter/finance/OrgSettlementList');
// 财务中心-结算单管理-结算账单(教育局)
const EduSettlementOld = () => import('@pv/orderCenter/finance/EduIndex');
// 财务中心-结算单管理-结算账单-详情(教育局)
const EduSettlementDetailsOld = () =>
  import('@pv/orderCenter/finance/OrgSettlementDetails');
// 财务中心-结算单管理-结算账单-机构结算单详情(教育局)
const OrgSettlementEduDetailsOld = () =>
  import('@pv/orderCenter/finance/OrgSettlementEduDetails');
// 财务中心-结算单管理-审批流程
const CheckFlowOld = () => import('@pv/orderCenter/finance/CheckFlow');

// 财务中心-结算单管理-结算账单(机构)
const OrgSettlement = () => import('@pv/orderCenter/newfinance/OrgIndex');
// 财务中心-结算单管理-结算账单(学校)
const SchSettlement = () => import('@pv/orderCenter/newfinance/SchIndex');
// 财务中心-结算单管理-结算账单-详情(机构)
const OrgSettlementDetails = () =>
  import('@pv/orderCenter/newfinance/OrgSettlementDetails');
// 学校端-教务确认单 财务中心-结算单管理-结算账单-详情(机构)
const OrgSettlementDetailsForSchoolSure = () =>
  import('@pv/orderCenter/newfinance/OrgSettlementDetailsForSchoolSure');
// 财务中心-结算单管理-结算账单-详情(学校)
const SchSettlementDetails = () =>
  import('@pv/orderCenter/newfinance/OrgSettlementDetails');
// 财务中心-结算单管理-结算账单-机构结算单详情 - 订单明细
const OrgSettlementList = () =>
  import('@pv/orderCenter/newfinance/OrgSettlementList');
// 财务中心-结算单管理-结算账单(教育局)
const EduSettlement = () => import('@pv/orderCenter/newfinance/EduIndex');
// 财务中心-结算单管理-结算账单-详情(教育局)
const EduSettlementDetails = () =>
  import('@pv/orderCenter/newfinance/OrgSettlementDetails');
// 财务中心-结算单管理-结算账单-机构结算单详情(教育局)
const OrgSettlementEduDetails = () =>
  import('@pv/orderCenter/newfinance/OrgSettlementEduDetails');
// 财务中心-结算单管理-审批流程
const CheckFlow = () => import('@pv/orderCenter/newfinance/CheckFlow');

// 财务中心-考勤结算-学校考勤确认单
const SchoolAttendList = () =>
  import('@pv/financeCenter/attendSettlement/SchoolAttendList');
// 财务中心-考勤结算-新增学校考勤确认单
const AddSchoolAttend = () =>
  import('@pv/financeCenter/attendSettlement/AddSchoolAttend');

// 财务中心-考勤结算-学校考勤确认单 - 支出明细
const PayList = () => import('@pv/financeCenter/attendSettlement/PayList.vue');
// 财务中心-考勤结算-教师考勤确认单
const TeacherAttendList = () =>
  import('@pv/financeCenter/attendSettlement/TeacherAttendList');
// 财务中心-考勤结算-教师考勤结算流程
const Process = () => import('@pv/financeCenter/attendSettlement/Process');
// 财务中心-考勤结算-教师考勤确认单（学校确认单详情版）
const AttendDetailed = () =>
  import('@pv/financeCenter/attendSettlement/AttendDetailed');

const FileDownloadPage = () => import('@pv/orderCenter/newfinance/FileDownloadPage');

const FeeConfirmation = () => import('@pv/financeCenter/reconciliation/FeeConfirmation');

const FeeConfirmationDetails = () => import('@pv/financeCenter/reconciliation/FeeConfirmationDetails');

const FeeComfirmOrderList = () => import('@pv/financeCenter/reconciliation/FeeComfirmOrderList');

export default [
  {
    path: '/financeCenter/oldSettlement/org',
    name: 'financeCenter_oldSettlement_org',
    meta: {
      title: '结算账单',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/oldSettlement/org',
      breadcrumb: '财务中心-结算单管理-结算账单'
    },
    component: OrgSettlementOld
  },
  {
    path: '/financeCenter/oldSettlement/sch',
    name: 'financeCenter_oldSettlement_sch',
    meta: {
      title: '结算账单-学校确认单',
      tableType: 2,
      tablePortOrg: '',
      activePath: '/financeCenter/oldSettlement/sch',
      breadcrumb: '财务中心-结算单管理-结算账单(学校确认单)'
    },
    component: SchSettlementOld
  },
  {
    path: '/financeCenter/oldSettlement/org/details',
    name: 'financeCenter_oldSettlement_org_details',
    meta: {
      title: '结算单详情',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/oldSettlement/org',
      breadcrumb: '财务中心-结算单管理-结算账单（机构）-结算单详情'
    },
    component: OrgSettlementDetailsOld
  },
  {
    path: '/financeCenter/oldSettlement/sch/details',
    name: 'financeCenter_oldSettlement_sch_details',
    meta: {
      title: '结算单详情',
      tableType: 2,
      tablePortOrg: '',
      activePath: '/financeCenter/oldSettlement/sch',
      breadcrumb: '财务中心-结算单管理-结算账单（学校）-结算单详情'
    },
    component: SchSettlementDetailsOld
  },
  {
    path: '/financeCenter/oldSettlement/sch/details/list',
    name: 'financeCenter_oldSettlement_sch_details_list',
    meta: {
      title: '订单明细',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/oldSettlement/sch',
      breadcrumb: '财务中心-结算单管理-结算账单(学校)-结算账单详情-订单明细'
    },
    component: OrgSettlementListOld
  },
  {
    path: '/financeCenter/oldSettlement/org/details/list',
    name: 'financeCenter_oldSettlement_org_details_list',
    meta: {
      title: '订单明细',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/oldSettlement/org',
      breadcrumb: '财务中心-结算单管理-结算账单(机构)-结算账单详情-订单明细'
    },
    component: OrgSettlementListOld
  },

  {
    path: '/financeCenter/oldSettlement/edu',
    name: 'financeCenter_oldSettlement_edu',
    meta: {
      title: '结算账单-教育局',
      tableType: 3,
      tablePortOrg: 'edu',
      activePath: '/financeCenter/oldSettlement/edu',
      breadcrumb: '财务中心-结算单管理-结算账单(教育局)'
    },
    component: EduSettlementOld
  },
  {
    path: '/financeCenter/oldSettlement/edu/details',
    name: 'financeCenter_oldSettlement_edu_details',
    meta: {
      title: '结算单详情',
      tableType: 3,
      tablePortOrg: 'edu',
      activePath: '/financeCenter/oldSettlement/edu',
      breadcrumb: '财务中心-结算单管理-结算账单（教育局）-结算单详情'
    },
    component: EduSettlementDetailsOld
  },

  {
    path: '/financeCenter/oldSettlement/edu/orgdetails',
    name: 'financeCenter_oldSettlement_edu_orgdetails',
    meta: {
      title: '结算单详情',
      tableType: 1,
      tablePortOrg: 'edu',
      activePath: '/financeCenter/oldSettlement/edu',
      breadcrumb: '财务中心-结算单管理-结算账单（教育局）-结算账单详情'
    },
    component: OrgSettlementEduDetailsOld
  },

  {
    path: '/financeCenter/oldSettlement/edu/checkFlow',
    name: 'financeCenter_oldSettlement_edu_checkFlow',
    meta: {
      title: '配置结算审批流程',
      tableType: 3,
      tablePortOrg: '',
      activePath: '/financeCenter/oldSettlement/edu',
      breadcrumb: '财务中心-结算单管理-结算账单（教育局）-配置结算审批流程'
    },
    component: CheckFlowOld
  },

  {
    path: '/financeCenter/oldSettlement/edu',
    name: 'financeCenter_oldSettlement_edu',
    meta: {
      title: '结算账单(教育局)',
      tableType: 3,
      tablePortOrg: '',
      activePath: '/financeCenter/oldSettlement/edu',
      breadcrumb: '财务中心-结算单管理-结算账单(教育局)'
    },
    component: EduSettlementOld
  },

  {
    path: '/financeCenter/settlement/org',
    name: 'financeCenter_settlement_org',
    meta: {
      title: '结算账单',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/settlement/org',
      breadcrumb: '财务中心-结算单管理-结算账单'
    },
    component: OrgSettlement
  },
  {
    path: '/financeCenter/settlement/sch',
    name: 'financeCenter_settlement_sch',
    meta: {
      title: '结算账单-学校确认单',
      tableType: 2,
      tablePortOrg: '',
      activePath: '/financeCenter/settlement/sch',
      breadcrumb: '财务中心-结算单管理-结算账单(学校确认单)'
    },
    component: SchSettlement
  },
  {
    path: '/financeCenter/settlement/org/details',
    name: 'financeCenter_settlement_org_details',
    meta: {
      title: '结算单详情',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/settlement/org',
      breadcrumb: '财务中心-结算单管理-结算账单（机构）-结算单详情'
    },
    component: OrgSettlementDetails
  },
  {
    path: '/financeCenter/settlement/org/detailsForSchoolSure',
    name: 'financeCenter_settlement_org_detailsForSchoolSure',
    meta: {
      title: '结算单详情',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/settlement/sch',
      breadcrumb: '财务中心-结算单管理-结算账单（机构）-结算单详情'
    },
    component: OrgSettlementDetailsForSchoolSure
  },
  {
    path: '/financeCenter/settlement/sch/details',
    name: 'financeCenter_settlement_sch_details',
    meta: {
      title: '结算单详情',
      tableType: 2,
      tablePortOrg: '',
      activePath: '/financeCenter/settlement/sch',
      breadcrumb: '财务中心-结算单管理-结算账单（学校）-结算单详情'
    },
    component: SchSettlementDetails
  },
  {
    path: '/financeCenter/settlement/sch/details/list',
    name: 'financeCenter_settlement_sch_details_list',
    meta: {
      title: '订单明细',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/settlement/sch',
      breadcrumb: '财务中心-结算单管理-结算账单(学校)-结算账单详情-订单明细'
    },
    component: OrgSettlementList
  },
  {
    path: '/financeCenter/settlement/org/details/list',
    name: 'financeCenter_settlement_org_details_list',
    meta: {
      title: '订单明细',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/settlement/org',
      breadcrumb: '财务中心-结算单管理-结算账单(机构)-结算账单详情-订单明细'
    },
    component: OrgSettlementList
  },

  {
    path: '/financeCenter/settlement/edu',
    name: 'financeCenter_settlement_edu',
    meta: {
      title: '结算账单-教育局',
      tableType: 3,
      tablePortOrg: 'edu',
      activePath: '/financeCenter/settlement/edu',
      breadcrumb: '财务中心-结算单管理-结算账单(教育局)'
    },
    component: EduSettlement
  },
  {
    path: '/financeCenter/settlement/edu/details',
    name: 'financeCenter_settlement_edu_details',
    meta: {
      title: '结算单详情',
      tableType: 3,
      tablePortOrg: 'edu',
      activePath: '/financeCenter/settlement/edu',
      breadcrumb: '财务中心-结算单管理-结算账单（教育局）-结算单详情'
    },
    component: EduSettlementDetails
  },

  {
    path: '/financeCenter/settlement/edu/orgdetails',
    name: 'financeCenter_settlement_edu_orgdetails',
    meta: {
      title: '结算单详情',
      tableType: 1,
      tablePortOrg: 'edu',
      activePath: '/financeCenter/settlement/edu',
      breadcrumb: '财务中心-结算单管理-结算账单（教育局）-结算账单详情'
    },
    component: OrgSettlementEduDetails
  },

  {
    path: '/financeCenter/settlement/edu/checkFlow',
    name: 'financeCenter_settlement_edu_checkFlow',
    meta: {
      title: '配置结算审批流程',
      tableType: 3,
      tablePortOrg: '',
      activePath: '/financeCenter/settlement/edu',
      breadcrumb: '财务中心-结算单管理-结算账单（教育局）-配置结算审批流程'
    },
    component: CheckFlow
  },

  {
    path: '/financeCenter/settlement/edu',
    name: 'financeCenter_settlement_edu',
    meta: {
      title: '结算账单(教育局)',
      tableType: 3,
      tablePortOrg: '',
      activePath: '/financeCenter/settlement/edu',
      breadcrumb: '财务中心-结算单管理-结算账单(教育局)'
    },
    component: EduSettlement
  },

  {
    path: '/financeCenter/attendSettlement/list',
    name: 'financeCenter_attendSettlement_list',
    meta: {
      title: '学校考勤确认单',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/attendSettlement/list',
      breadcrumb: '财务中心-考勤结算-学校考勤确认单'
    },
    component: SchoolAttendList
  },
  {
    path: '/financeCenter/attendSettlement/list/add',
    name: 'financeCenter_attendSettlement_list_add',
    meta: {
      title: '新增学校考勤确认单',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/attendSettlement/list',
      breadcrumb: '财务中心-考勤结算-新增学校考勤确认单'
    },
    component: AddSchoolAttend
  },
  {
    path: '/financeCenter/attendSettlement/list/payList',
    name: 'financeCenter_attendSettlement_payList',
    meta: {
      title: '费用支出明细',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/attendSettlement/list',
      breadcrumb: '财务中心-考勤结算-费用支出明细'
    },
    component: PayList
  },
  {
    path: '/financeCenter/attendSettlement/teacher',
    name: 'financeCenter_attendSettlement_teacher',
    meta: {
      title: '教师考勤确认单',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/attendSettlement/teacher',
      breadcrumb: '财务中心-考勤结算-教师考勤确认单'
    },
    component: TeacherAttendList
  },
  {
    path: '/financeCenter/attendSettlement/process',
    name: 'financeCenter_attendSettlement_process',
    meta: {
      title: '教师考勤结算流程',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/attendSettlement/list',
      breadcrumb: '财务中心-考勤结算-学校考勤确认单-教师考勤结算流程'
    },
    component: Process
  },
  {
    path: '/financeCenter/attendSettlement/attendDetailed',
    name: 'financeCenter_attendSettlement_attendDetailed',
    meta: {
      title: '教师考勤确认单',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/attendSettlement/list',
      breadcrumb: '财务中心-考勤结算-学校考勤确认单-教师考勤确认单'
    },
    component: AttendDetailed
  },
  {
    path: '/financeCenter/settlement/org/fileDownload',
    name: 'financeCenter_settlement_org_fileDownload',
    meta: {
      title: '文件管理',
      tableType: 1,
      tablePortOrg: '',
      activePath: '/financeCenter/settlement/org',
      breadcrumb: '财务中心-结算单管理-结算账单（机构）-文件管理'
    },
    component: FileDownloadPage
  },
  {
    path: '/financeCenter/reconciliation/feeConfirmation',
    name: 'financeCenter_reconciliation_feeConfirmation',
    meta: {
      title: '对账中心-收费确认单',
      activePath: '/financeCenter/reconciliation/feeConfirmation',
      breadcrumb: '财务中心-对账中心-收费确认单'
    },
    component: FeeConfirmation
  },
  {
    path: '/financeCenter/reconciliation/feeConfirmation/details',
    name: 'financeCenter_reconciliation_feeConfirmation_details',
    meta: {
      title: '对账中心-收费确认单-详情',
      activePath: '/financeCenter/reconciliation/feeConfirmation',
      breadcrumb: '财务中心-对账中心-收费确认单-详情'
    },
    component: FeeConfirmationDetails
  },
  {
    path: '/financeCenter/reconciliation/feeConfirmation/orderList',
    name: 'financeCenter_reconciliation_feeConfirmation_orderList',
    meta: {
      title: '对账中心-收费确认单-订单结算明细',
      activePath: '/financeCenter/reconciliation/feeConfirmation',
      breadcrumb: '财务中心-对账中心-收费确认单-订单结算明细'
    },
    component: FeeComfirmOrderList
  }

];
